import { Route, Routes, useOutlet } from 'react-router';
import { systemPrototypeDetailRouteRef } from '../routes';
import { PrototypeListPage } from './PrototypeListPage';
import { SystemPrototypeDetailsPage } from './SystemPrototypeDetailsPage';
import { useElementFilter } from '@mainstage/core-plugin-api';
import {
  LAYOUTS_KEY,
  LAYOUTS_WRAPPER_KEY,
  LayoutOptions,
} from '@agilelab/plugin-wb-scaffolder';

/**
 * The props for the entrypoint `PrototypePage` component the plugin.
 * @public
 */
export type RouterProps = {
  layouts?: LayoutOptions[];
};

/**
 * The main entrypoint `Router` for the `PrototypePlugin`.
 *
 * @public
 */
export const Router = () => {
  const outlet = useOutlet();

  const customLayouts = useElementFilter(outlet, elements =>
    elements
      .selectByComponentData({
        key: LAYOUTS_WRAPPER_KEY,
      })
      .findComponentData<LayoutOptions>({
        key: LAYOUTS_KEY,
      }),
  );

  return (
    <Routes>
      <Route path="/" element={<PrototypeListPage />} />
      <Route
        path={systemPrototypeDetailRouteRef.path}
        element={<SystemPrototypeDetailsPage layouts={customLayouts} />}
      />
    </Routes>
  );
};
